@let groups = $groups();
@let context = $context();
<!-- {} -->

@if (groups?.length) {
  <accordion [multi]="true">
    @for (group of groups; track group?._id) {
      <accordion-group [title]="group?.date ?? 'No Group'" displayBox="flex" [showTitleLine]="true" [expanded]="true">
        @for (item of group?.items; track item.activity._id; let first = $first; let last = $last) {
          <activity-item [context]="context" [isFirst]="first" [isLast]="last" [activity]="item.activity" [threadChildren]="item.threadChildren" [hiddenChildCount]="item.hiddenChildCount" [threadCollapsible]="item.threadCollapsible" (toggleThread)="toggleThread($event)" (edit)="edit.emit($event)" (delete)="delete.emit($event)" (share)="share.emit($event)" (threadResolvedChange)="onThreadResolvedChange($event)" />
        }
      </accordion-group>
    }
  </accordion>
} @else {
  <empty-message message="No Activities Found." icon=""></empty-message>
}